import { IsArray, IsDefined, IsOptional, IsString } from 'class-validator';
import { BaseDto } from '../base.dto';
import type { GiftCardBenefitSetupDto } from './giftCardBenefitSetup.dto';

export class GiftCardBenefitFrequencyDto extends BaseDto {
  @IsDefined()
  @IsString()
  name: string;

  @IsDefined()
  @IsString()
  intervalISO8601: string;

  @IsOptional()
  @IsArray()
  benefitSetups?: GiftCardBenefitSetupDto[];
}
